/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

const OnepageMenuItems = (props) => {
    const { menuItem1, menuItem2, menuItem3, menuItem4, menuItem5, menuItem6, menuItem7 } = props;

    const [home, setHome] = useState(true)
    const [about, setAbout] = useState(false)
    const [service, setService] = useState(false)
    const [portfolio, setPortfolio] = useState(false)
    const [team, setTeam] = useState(false)
    const [blog, setBlog] = useState(false)
    const [contact, setContact] = useState(false)

    const addActiveClass = (menu) => {

        if (menu === 'home') {
            setHome(!home)
            setAbout(false)
            setService(false)
            setPortfolio(false)
            setTeam(false)
            setBlog(false)
            setContact(false)
        }
        else if (menu === 'about') {
            setHome(false)
            setAbout(!home)
            setService(false)
            setPortfolio(false)
            setTeam(false)
            setBlog(false)
            setContact(false)
        }
        else if (menu === 'service') {
            setHome(false)
            setAbout(false)
            setService(!home)
            setPortfolio(false)
            setTeam(false)
            setBlog(false)
            setContact(false)
        }
        else if (menu === 'portfolio') {
            setHome(false)
            setAbout(false)
            setService(false)
            setPortfolio(!home)
            setTeam(false)
            setBlog(false)
            setContact(false)
        }
        else if (menu === 'team') {
            setHome(false)
            setAbout(false)
            setService(false)
            setPortfolio(false)
            setTeam(!home)
            setBlog(false)
            setContact(false)
        }
        else if (menu === 'blog') {
            setHome(false)
            setAbout(false)
            setService(false)
            setPortfolio(false)
            setTeam(false)
            setBlog(!home)
            setContact(false)
        }
        else if (menu === 'contact') {
            setHome(false)
            setAbout(false)
            setService(false)
            setPortfolio(false)
            setTeam(false)
            setBlog(false)
            setContact(!home)
        }
    };

    const scrollToSection = (sectionIds) => {
        const target = sectionIds
            .map((sectionId) => document.getElementById(sectionId))
            .find(Boolean);

        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <React.Fragment>
            {
                menuItem1 ?
                    <li className={home ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('home'); scrollToSection(['rs-header']); }}>
                            {menuItem1} 
                        </a>
                    </li> : ''
            }
            {
                menuItem2 ?
                    <li className={about ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('about'); scrollToSection(['rs-about', 'rs-corporate-legacy']); }}>
                            {menuItem2} 
                        </a>
                    </li> : ''
            }

            {
                menuItem3 ?
                    <li className={service ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('service'); scrollToSection(['rs-service']); }}>
                            {menuItem3} 
                        </a>
                    </li> : ''
            }

            {
                menuItem4 ?
                    <li className={portfolio ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('portfolio'); scrollToSection(['rs-portfolio']); }}>
                            {menuItem4} 
                        </a>
                    </li> : ''
            }

            {
                menuItem5 ?
                    <li className={team ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('team'); scrollToSection(['rs-team']); }}>
                            {menuItem5} 
                        </a>
                    </li> : ''
            }

            {
                menuItem6 ?
                    <li className={blog ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('blog'); scrollToSection(['rs-blog']); }}>
                            {menuItem6} 
                        </a>
                    </li> : ''
            }

            {
                menuItem7 ?
                    <li className={contact ? "current-menu-item" : ""}>
                        <a onClick={(event) => { event.preventDefault(); addActiveClass('contact'); scrollToSection(['rs-contact']); }}>
                            {menuItem7} 
                        </a>
                    </li> : ''
            }

        </React.Fragment>
    );
}

export default OnepageMenuItems;
